var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import { updatePhoto } from '../../Photo/store/actions';
import { updatePhotoProductItem, updateSelectedProductItem } from '../store/actions';
var mapDispatchToProps = {
    updatePhoto: updatePhoto,
    updateSelectedProductItem: updateSelectedProductItem,
    updatePhotoProductItem: updatePhotoProductItem,
};
var connector = connect(null, mapDispatchToProps);
var ProductItemList = /** @class */ (function (_super) {
    __extends(ProductItemList, _super);
    function ProductItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isResizing: false,
        };
        _this.isResizing = false;
        _this.debouncedPhotoUpdate = null;
        _this.debouncedWindowResize = null;
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    ProductItemList.prototype.componentDidMount = function () {
        var _this = this;
        this.debouncedWindowResize = debounce(function () {
            _this.isResizing = false;
            _this.setState({ isResizing: false });
        }, 500);
        this.debouncedPhotoUpdate = debounce(function (photo, productItem) {
            _this.props.updatePhoto(photo, {
                product_item_id: productItem.id,
            });
        }, 700);
        window.addEventListener('resize', this.handleWindowResize);
    };
    ProductItemList.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    ProductItemList.prototype.render = function () {
        var _this = this;
        var _a;
        if (((_a = this.props.productItems) === null || _a === void 0 ? void 0 : _a.length) <= 1) {
            return null;
        }
        return (React.createElement("div", { className: "c-cart-item-editor-product-items" }, this.props.productItems.map(function (item, key) {
            var isActive = !_this.props.selectedProductItem
                ? 0 === key
                : _this.props.selectedProductItem.id === item.id;
            var spritableProducts = [4, 5, 6];
            var isSpritable = spritableProducts.includes(item.product_id);
            return (React.createElement("div", { key: item.id, className: "c-cart-item-editor-product-items__item__wrapper", title: item.name, onClick: function () { return _this.handleClick(item); } },
                React.createElement("div", { className: "c-cart-item-editor-product-items__item" + (isSpritable ? ' c-cart-item-editor-product-items__item--spritable' : '') + (isActive ? ' c-cart-item-editor-product-items__item--active' : ''), style: { backgroundImage: "url(/images/product-items/thumbnails/" + item.id + ".png?v1" } }, isActive && React.createElement("i", { className: "icon-check-circle" }))));
        })));
    };
    ProductItemList.prototype.handleWindowResize = function () {
        if (!this.isResizing) {
            this.isResizing = true;
            this.setState({ isResizing: true });
        }
        if (!this.debouncedWindowResize) {
            return;
        }
        this.debouncedWindowResize();
    };
    ProductItemList.prototype.handleClick = function (item) {
        if (!this.props.selectedPhoto) {
            return;
        }
        this.props.updateSelectedProductItem(item);
        this.props.updatePhotoProductItem(this.props.selectedPhoto, item);
        if (this.debouncedPhotoUpdate) {
            this.debouncedPhotoUpdate(this.props.selectedPhoto, item);
        }
    };
    return ProductItemList;
}(React.Component));
export default connector(ProductItemList);
